import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { Column } from '../../../../common/tables/table'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-dynamic-property-header',
  templateUrl: './dynamic-property-header.component.html',
  styleUrls: ['./dynamic-property-header.component.scss'],
  imports: [AsyncPipe, ElderTranslatePipe],
})
export class DynamicPropertyHeaderComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private _column$ = new BehaviorSubject<Column>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set column(cd: Column) {
    this._column$.next(cd)
  }

  public get column(): Column {
    return this._column$.getValue()
  }

  public get column$(): Observable<Column> {
    return this._column$.asObservable()
  }
}
